import extractOrganizationData from '../../data_management/extractOrganizationData'
import getPeople from '../../data_management/getPeople'
import buildPathForEntity from '../../util/build_path_for_entity'
import EntityHelper from '../../util/entity_helper'

const OrganizationsList = function ($location, $scope, initialDataInteractor, organizationInteractor) {
  const $ctrl = this;

  $ctrl.helper = new EntityHelper("members");

  $ctrl.$onInit = function () {
    $ctrl.newOrganizationName = '';
    initialDataInteractor.ensureInitializedSession().then(() => $scope.$evalAsync(() => {
      $ctrl.people = getPeople(initialDataInteractor);
      $ctrl.organizations = extractOrganizationData(initialDataInteractor);
    }));
  };

  $ctrl.peopleSummary = function (organization) {
    let people = organization.members.map(id => findPersonById(id));
    return $ctrl.helper.itemSummaryString(people, member => member ? member.name : '?Error?');
  };

  $ctrl.getEntityName = function (organization) {
    return organization.name;
  };

  $ctrl.createNewOrganization = function () {
    organizationInteractor.createNewOrganization($ctrl.newOrganizationName, function () {
      $ctrl.organizations = extractOrganizationData(initialDataInteractor);
      $scope.$apply();
    });
  };

  $ctrl.isCreateOrganizationDisabled = function() {
    return $ctrl.newOrganizationName.length === 0;
  };

  $ctrl.userDidClickEntity = function (organization) {
    $scope.$evalAsync(() => {
      let path = buildPathForEntity('organization', organization.id);
      $location.path(path)
    });
  };

  function findPersonById(id) {
    return $ctrl.people.find(p => p.id == id);
  }
};

export default {
  name: 'organizationsList',
  obj: {
    controller: OrganizationsList,
    templateUrl: 'components/organizations_list.html'
  },
  deps: []
};
